import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import errorListServices from '@src/services/errorList/errorList.services';

export const getTicketCarProviderLogs = createAsyncThunk(
  'getTicketCarProviderLogs',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { pageNumber = 1, pageSize = 10, customerId = null, filter = null } = body;
      const res = await errorListServices.getTicketCarProviderLogs({
        pageNumber,
        pageSize,
        customerId,
        filter,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateTicketCarProviderLogs = createAsyncThunk(
  'updateTicketCarProviderLogs',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { ids } = body;
      const res = await errorListServices.updateTicketCarProviderLogs(ids);
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  ticketCarProviderLogsResponseItemList: [],
  providerList: [],
  operationList: [],
  statusList: [],
  plateList: [],
  customerList: [],
  fleetList: [],
  loading: {
    ticketCarProviderLogsResponseItemList: false,
  },
  pagedProperty: {
    pageSize: 0,
    totalItems: 0,
    currentPage: 1,
  },
};

export const errorListSlice = createSlice({
  name: 'errorList',
  initialState,
  reducers: {
    resetCurrentLoadVehicleManagement: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTicketCarProviderLogs.pending, (state) => {
        state.loading.ticketCarProviderLogsResponseItemList = true;
      })
      .addCase(getTicketCarProviderLogs.fulfilled, (state, action) => {
        state.loading.ticketCarProviderLogsResponseItemList = false;
        state.plateList = action?.payload?.data?.plateList || [];
        state.customerList = action?.payload?.data?.customerList || [];
        state.fleetList = action?.payload?.data?.fleetList || [];
        state.statusList = action?.payload?.data?.statusList || [];
        state.operationList = action?.payload?.data?.operationList || [];
        state.providerList = action?.payload?.data?.providerList || [];
        state.ticketCarProviderLogsResponseItemList =
          action?.payload?.data?.ticketCarProviderLogsResponseItemList || [];
        state.pagedProperty.pageSize = action?.payload?.pageSize || 0;
        state.pagedProperty.totalItems = action?.payload?.totalItems || 0;
        state.pagedProperty.currentPage = action?.payload?.currentPage || 1;
      })
      .addCase(getTicketCarProviderLogs.rejected, (state, action) => {
        state.loading.ticketCarProviderLogsResponseItemList = false;
        state.ticketCarProviderLogsResponseItemList = [];
        state.providerList = [];
        state.operationList = [];
        state.statusList = [];
        state.plateList = [];
        state.customerList = [];
        state.fleetList = [];
        state.pagedProperty = {
          pageSize: 0,
          totalItems: 0,
          currentPage: 1,
        };
        state.error = action.payload || 'Error';
      });
  },
});

export const { resetCurrentLoadVehicleManagement } = errorListSlice.actions;
